import {ReactElement, useEffect, useRef} from 'react'
import {Button, Card, Typography} from '@material-ui/core'
import {FlashOn} from '@material-ui/icons'
import {useHistory} from 'react-router-dom'
import {useQueryApiV2} from '../../../shared/hooks/use-query-api-v2'
import {recordPromotionEvent} from './api'
import {CurrentPromotion} from './types'
import {highlightPromotionTitleParts, promotionBannerEyebrow} from './promotionCopy'
import './tenx-promotion.css'

export function PromotionBanner(): ReactElement | null {
  const history = useHistory()
  const viewed = useRef(false)
  const [promotion, {loading, error}] = useQueryApiV2<CurrentPromotion | null>({path: '/dashboard/promotions/current'})
  const campaign = promotion?.campaign
  useEffect(() => {
    if (!campaign || viewed.current) return
    viewed.current = true
    recordPromotionEvent(campaign.id, {event: 'banner_view'}).catch(() => undefined)
  }, [campaign])
  if (loading || error || !campaign || !campaign.rules.promotion.display.bannerEnabled) return null
  const {display} = campaign.rules.promotion
  return (
    <Card className="pm-banner" data-testid="pm-banner" elevation={0} role="region" aria-label="Tauro 10x offer">
      <div className="pm-banner__copy">
        <Typography className="pm-banner__kicker" component="p">
          <FlashOn className="pm-banner__eyebrow-icon" />
          {promotionBannerEyebrow(promotion.maxMultiplier)}
        </Typography>
        <Typography className="pm-banner__title" component="h2">
          {highlightPromotionTitleParts(display.bannerTitle).map((part, index) =>
            part.type === 'money' ? (
              <em key={index} className="pm-banner__money">
                {part.value}
              </em>
            ) : (
              <span key={index}>{part.value}</span>
            ),
          )}
        </Typography>
        <Typography className="pm-banner__text" component="p">
          {display.bannerText}
        </Typography>
      </div>
      <div className="pm-banner__actions">
        <Typography className="pm-banner__until" component="span">
          Until {new Date(campaign.end).toLocaleDateString()}
        </Typography>
        <Button
          className="pm-btn"
          variant="contained"
          disableElevation
          onClick={() => {
            recordPromotionEvent(campaign.id, {event: 'banner_click'}).catch(() => undefined)
            history.push('/accounts/promotion')
          }}
        >
          See the offers →
        </Button>
      </div>
    </Card>
  )
}
